/**
 * Products API service.
 */
import { api } from './api'
import type {
  Product, TShirtSizeConfig, ProductBundle, PaginatedResponse, AppriseVmOptions, AzureCatalogResponse,
  AzureSubscriptionInfo, AzureCatalogItems, AzureCatalogKind, AzureCatalogParams,
} from '@/types'

export const productsApi = {
  list: () => api.get<PaginatedResponse<Product>>('/products/'),

  getSizeConfigs: (productId?: number) =>
    api.get<PaginatedResponse<TShirtSizeConfig>>('/products/sizes/', {
      params: productId ? { product: productId } : undefined,
    }),

  getBundles: () => api.get<PaginatedResponse<ProductBundle>>('/products/bundles/'),

  getAppriseVmOptions: () => api.get<AppriseVmOptions>('/products/apprise-vm/options/'),

  // Apprise-on-VM: live, read-only Azure data (HTTP 200 + source "fallback" when Azure is unreachable).
  getAppriseAzureSubscription: () => api.get<AzureSubscriptionInfo>('/products/apprise-vm/azure/subscription/'),

  getAppriseAzureCatalog: <K extends AzureCatalogKind>(kind: K, params?: AzureCatalogParams) =>
    api.get<AzureCatalogResponse<AzureCatalogItems[K]>>(`/products/apprise-vm/azure/${kind}/`, { params }),
}
